export const MESSAGE_EVENT = {
  CHAT: 'WS:CHAT_MESSAGE_CHECK',
  CLINIC: 'WS:CLINIC_CHAT_MESSAGE_CHECK',
};
